
/* eslint-disable */
import AwsExports from '@/.config/aws-exports'
import Amplify from 'aws-amplify'
import * as queries from '@/graphql/queries.js'
import * as mutations from '@/graphql/mutations.js'
import API, { graphqlOperation } from '@aws-amplify/api'

Amplify.configure(AwsExports)

export class SPR_URL {
  static baseUrl () {
    const hostname = location.hostname
    const env = hostname.split('.')[0]
    if (env === 'local' || env === 'localhost' || env === 'qa1') {
      // QA・local環境
      return 'https://qa1-api.ccsapp.jp/api'
    } else if (env === 'ccsapp') {
      // 本番環境
      return 'https://api.ccsapp.jp/api'
    }
  }
  static getUrl (method) {
    return this.baseUrl() + ENDPOINTS[method]['endpoint']
  }
}

export class LAM_URL {
  static async baseUrl () {
    const hostname = location.hostname
    const env = hostname.split('.')[0]
    if (env === 'local' || env === 'localhost' || env === 'qa1') {
      // QA・local環境
      return 'https://dev-api.ccsapp.jp'
      // return 'https://mrb2uijegc.execute-api.ap-northeast-1.amazonaws.com/dev2'
    } else if (env === 'ccsapp') {
      // 本番環境
      return 'https://prod-api.ccsapp.jp'
      // return 'https://l6zmwgh6j9.execute-api.ap-northeast-1.amazonaws.com/prod'
    }
  }
  static async getUrl (method) {
    return (await this.baseUrl() + ENDPOINTS[method]['endpoint'])
  }
}

export class APPSYNC_URL {
  static async fetchContactBook (data) {
    try {
      return (await API.graphql(
        graphqlOperation(queries.getGlobalBridgeContactBookRecord, data)
      )).data.getGlobalBridgeContactBookRecord
    } catch (error) {
      throw error
    }
  }
  static async fetchAdminMast (data) {
    // sub
    try {
      return (await API.graphql(
        graphqlOperation(queries.getGlobalBridgeAdminMast, data)
      )).data.getGlobalBridgeAdminMast
    } catch (error) {
      throw error
    }
  }
  static async fetchAdminMastList () {
    try {
      return (await API.graphql(
        graphqlOperation(queries.listGlobalBridgeAdminMast)
      )).data.listGlobalBridgeAdminMast
    } catch (error) {
      throw error
    }
  }
  static async fetchSchoolMastList () {
    try {
      return (await API.graphql(
        graphqlOperation(queries.listGlobalBridgeSchoolMast)
      )).data.listGlobalBridgeSchoolMast
    } catch (error) {
      throw error
    }
  }
  static async fetchCcsMastList () {
    try {
      return (await API.graphql(
        graphqlOperation(queries.listGlobalBridgeCcsMast)
      )).data.listGlobalBridgeCcsMast
    } catch (error) {
      throw error
    }
  }
  static async createAdminMast (data) {
    try {
      return (await API.graphql(
        graphqlOperation(mutations.createGlobalBridgeAdminMast, { input: data })
      )).data.createGlobalBridgeAdminMast
    } catch (error) {
      throw error
    }
  }
  static async updateAdminMast (data) {
    try {
      return (await API.graphql(
        graphqlOperation(mutations.updateGlobalBridgeAdminMast, { input: data })
      ))
    } catch (error) {
      throw error
    }
  }
  static async updateSchoolMast (data) {
    try {
      return (await API.graphql(
        graphqlOperation(mutations.updateGlobalBridgeSchoolMast, { input: data })
      ))
    } catch (error) {
      throw error
    }
  }
  static async fetchMaintenanceMessageList () {
    try {
      return (await API.graphql(
        graphqlOperation(queries.listGlobalBridgeMaintenanceMessage)
      )).data.listGlobalBridgeMaintenanceMessage
    } catch (error) {
      throw error
    }
  }
}

export class CCS_URL {
  static baseUrl () {
    const hostname = location.hostname
    const env = hostname.split('.')[0]
    if (env === 'local' || env === 'localhost' || env === 'qa1') {
      // QA・local環境
      return 'https://ccsp-staging.c-c-system.com/'
      // return 'https://p001.c-c-system.com/'
    } else if (env === 'ccsapp') {
      // 本番環境
      return 'https://p001.c-c-system.com/'
    }
  }
  static getUrl (method, nurseryCode, serverId) {
    if (nurseryCode) {
      return this.baseUrl() + nurseryCode + ENDPOINTS[method]['endpoint']
    } else {
      const hostname = location.hostname
      const env = hostname.split('.')[0]
      if (env === 'ccsapp') {
        // 本番環境
        return `https://${serverId ? serverId : 'p001'}.c-c-system.com/ccsproadmin` + ENDPOINTS[method]['endpoint']
      } else {
        // QA・local環境
        return `https://${serverId ? serverId : 'ccsp-staging'}.c-c-system.com/ccspstagingadmin` + ENDPOINTS[method]['endpoint']
      }
    }
  }
}

export const ENDPOINTS = {
  ccsSignIn: {endpoint: '/ccs/cmb_api/auth/admin'},
  ccsFetchSchoolList: {endpoint: '/ccs/cmb_api/nursery/list'},
  ccsFetchNurseList: {endpoint: '/ccs/cmb_api/staff/list'},
  ccsFetchChildList: {endpoint: '/ccs/cmb_api/child/list'},
  ccsFetchChildInfo: {endpoint: '/ccs/cmb_api/child/info'},
  ccsFetchChildDetailInfo: {endpoint: '/ccs/cmb_api/child/detailinfo'},
  sprFetchMaintenance: {endpoint: '/admin/maintenance/read'},
  sprPostMaintenanceStatus: {endpoint: '/admin/maintenance/status'},
  sprFetchMaintenanceMessage: {endpoint: '/admin/maintenance/message'},
  sprPosthMaintenanceMessage: {endpoint: '/admin/maintenance/set_message'}
}



// WEBPACK FOOTER //
// ./src/api/url.js